import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { OfferSingle } from "@/services/offers/OfferSingle";
import OfferStatisticChart from "@/components/offers/offer/OfferStatisticChart.vue";
import BaseEditableCard from '@/components-UI/BaseEditableCard.vue';
import OfferMetricsTable from "@/components/offers/offer/metrics/OfferMetricsTable.vue";
import BaseList from '@/components-UI/list/BaseList.vue';
import BaseListItem from '@/components-UI/list/BaseListItem.vue';
import { IItemsFromOffers } from '@/api/types/offers';
import ViewDateTime from "@/components/base/ViewDateTime.vue";

interface Props {
    offer: OfferSingle,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferMetrics',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: OfferSingle,
}



const isOfferEmpty = computed<boolean>(() => {
    return Object.keys(props.offer)?.length <= 0;
});

const stats = computed<{ label: string, value: string }>(() => {
    return [
        { label: 'Статистика', value: mapArrayFields(props.offer.stats), type: 'string' },
        { label: 'Выплата', value: mapArrayFields(props.offer.payouts), type: 'string' },
        { label: 'Последний принятый лид', value: props.offer.last_lead_date, type: 'date' },
        { label: 'Загрузка отчёта', value: props.offer.last_report_date, type: 'date' },
    ];
});

const mapArrayFields = (items: IItemsFromOffers[]): string => {
    return items?.map((i) => i.name).join(', ');
};

return { __sfc: true,props, isOfferEmpty, stats, mapArrayFields, OfferStatisticChart, BaseEditableCard, OfferMetricsTable, BaseList, BaseListItem, ViewDateTime }
}

})